const TIMESTAMP_UNSET = -1;

export {TIMESTAMP_UNSET}